import { render, staticRenderFns } from "./CreateAppeal.vue?vue&type=template&id=1dbcdada&"
import script from "./CreateAppeal.vue?vue&type=script&lang=js&"
export * from "./CreateAppeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports